import $request from '../../utils/request';
import { toYuan } from '../../utils/unit-conversion';
var state = {
    balanceData: {},
    onlineDebit: 0,
    statistics: {},
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    // 获取余额
    GET_BALANCE: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        if (params === void 0) { params = { loadingControl: 'auto', loading: null }; }
        var loadingControl = params.loadingControl, loading = params.loading;
        $request({
            url: 'proxy/api/account/balance',
            method: 'post',
            loadingControl: loadingControl,
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    balanceData: res.data,
                });
                return;
            }
            loading && loading.close();
            // this.$store.commonLoading.close()
        });
    },
    // TODO: 获取资方还款 2.1可能废弃掉
    GET_FUNDREPAY: function (_a, param) {
        var commit = _a.commit;
        $request({
            url: '/proxy/api/capital/statistic/tenant/repay',
            method: 'post',
            data: param,
            loadingControl: 'hand',
        }).then(function (res) {
            if (!res || res.errorCode !== 0) {
                return;
            }
            var onlineDebit = res.data.onlineDebit;
            commit('update', {
                onlineDebit: onlineDebit,
            });
        });
    },
    // 获取统计数据
    GET_STATISTICS: function (_a, param) {
        var commit = _a.commit;
        commit('update', {
            statistics: {},
        });
        $request({
            url: '/proxy/api/account/trade/statistics',
            method: 'post',
            data: param,
        }).then(function (res) {
            if (!res || res.errorCode !== 0 || !res.data || typeof res.data !== 'object') {
                return;
            }
            var _a = res.data, totalIncomeAmount = _a.totalIncomeAmount, totalCostAmount = _a.totalCostAmount, totalRentAmount = _a.totalRentAmount, dayGreedAmount = _a.dayGreedAmount, dayAverageAmount = _a.dayAverageAmount, activeAmount = _a.activeAmount, totalFeeAmount = _a.totalFeeAmount, trafficFineAmount = _a.trafficFineAmount, depositAmount = _a.depositAmount, insureAmount = _a.insureAmount, manageFeeAmount = _a.manageFeeAmount, otherFeeAmount = _a.otherFeeAmount, transferAccountAmount = _a.transferAccountAmount, totalDriverAwardAmount = _a.totalDriverAwardAmount, awardAmount = _a.awardAmount, subsidyAmount = _a.subsidyAmount, refundAmount = _a.refundAmount, totalWithdrawAmount = _a.totalWithdrawAmount, withdrawAmount = _a.withdrawAmount, withdrawFee = _a.withdrawFee, activeFee = _a.activeFee, trafficViolationQueryFee = _a.trafficViolationQueryFee, cpRentDeductAmount = _a.cpRentDeductAmount, transferOutAmount = _a.transferOutAmount;
            var statistics = {
                //入账
                totalIncome: {
                    type: '入账总额',
                    value: totalIncomeAmount,
                    children: [
                        {
                            // 租金入账
                            type: '租金入账总额',
                            value: totalRentAmount,
                            showType: 'chart',
                            children: [
                                {
                                    type: '日扣优先',
                                    value: toYuan(dayGreedAmount),
                                },
                                {
                                    type: '日扣平均',
                                    value: toYuan(dayAverageAmount),
                                },
                                {
                                    type: '主动还款',
                                    value: toYuan(activeAmount),
                                },
                            ],
                        },
                        {
                            // 收费入账
                            type: '收费入账总额',
                            value: totalFeeAmount,
                            children: [
                                {
                                    type: '违章罚款',
                                    value: trafficFineAmount,
                                },
                                {
                                    type: '押金',
                                    value: depositAmount,
                                },
                                {
                                    type: '保险',
                                    value: insureAmount,
                                },
                                {
                                    type: '管理费',
                                    value: manageFeeAmount,
                                },
                                {
                                    type: '其他',
                                    value: otherFeeAmount,
                                },
                            ],
                        },
                        {
                            type: '转账',
                            value: transferAccountAmount,
                        },
                    ],
                },
                // 入账
                totalCost: {
                    type: '入账总额',
                    value: totalCostAmount,
                    children: [
                        {
                            type: '司机奖励补贴',
                            value: totalDriverAwardAmount,
                            children: [
                                {
                                    type: '奖励',
                                    value: awardAmount,
                                },
                                {
                                    type: '补贴',
                                    value: subsidyAmount,
                                },
                                {
                                    type: '退款',
                                    value: refundAmount,
                                },
                            ],
                        },
                        {
                            type: '提现总额',
                            value: totalWithdrawAmount,
                            children: [
                                {
                                    type: '提现到账',
                                    value: withdrawAmount,
                                },
                                {
                                    type: '提现手续费',
                                    value: withdrawFee,
                                },
                            ],
                        },
                        {
                            type: '主动还款手续费',
                            value: activeFee,
                        },
                        {
                            type: '违章查询费',
                            value: trafficViolationQueryFee,
                        },
                        {
                            type: '资方还款',
                            value: cpRentDeductAmount,
                        },
                        {
                            type: '转账',
                            value: transferOutAmount,
                        },
                    ],
                },
            };
            commit('update', {
                statistics: statistics,
            });
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
